import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelTripTypeSlice = createSlice({
  name: "getTravelTripType",
  initialState,
  reducers: {
    getTravelTripTypeStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelTripTypeSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelTripTypeFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelTripTypeStart,
  getTravelTripTypeSuccess,
  getTravelTripTypeFailure,
  clearError,
  clearMessage,
} = getTravelTripTypeSlice.actions;

export default getTravelTripTypeSlice.reducer;
